import { render, staticRenderFns } from "./headerTag.vue?vue&type=template&id=035e73ec&scoped=true&"
import script from "./headerTag.vue?vue&type=script&lang=js&"
export * from "./headerTag.vue?vue&type=script&lang=js&"
import style0 from "./headerTag.vue?vue&type=style&index=0&id=035e73ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035e73ec",
  null
  
)

component.options.__file = "headerTag.vue"
export default component.exports